<template>
  <div class="card mb-3">
    <div class="card-header">
      <h6 class="m-0 font-weight-bold text-primary">General Info</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-nama" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Nama Lengkap <sup class="text-danger">*</sup></label>
            <input type="text" class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-nama" placeholder="Nama Lengkap" autocomplete="off" v-model="data.name" >
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-city" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Kota <sup class="text-danger">*</sup></label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-city" v-model="data.city">
              <option value="" selected="" disabled>Pilih Kota</option>
              <option v-for="(data,index) in city_arr" :value="data.id" :key="index">{{ data.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-email" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Email <sup class="text-danger">*</sup></label>
            <input type="text" class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-email" placeholder="Email" v-model="data.email" >
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-address" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Address <sup class="text-danger">*</sup></label>
            <input type="text" class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-address" placeholder="Address" v-model="data.address" >
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-telp" class="col-lg-4 pl-0 m-0 d-flex align-items-center">No. Telp <sup class="text-danger">*</sup></label>
            <div class="input-group col-lg-8 mb-4 mb-lg-0 p-0">
              <input type="text" class="form-control" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-telp" placeholder="81234567xxx" v-model="data.phone_number" >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  props:[
    'data',
    'is_allow_edit',
  ],
  components:{
    'v-date-picker': DatePicker
  },
  data(){
    return{
      city_arr: [],
    }
  },
  created(){
    this.get_city_data()
  },
  methods: {
    async get_city_data(){
      var response = await axios.get(base_url+'/city/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.city_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
  }
}
</script>
